import Image from "next/image";
import Link from "next/link";
import { cn } from "~/lib/utils";

type ArticleCardProps = {
  title: string;
  date: string;
  image: string;
  author: string;
  link: string;
};

const ArticleCard = ({
  title,
  date,
  image,
  author,
  link,
}: ArticleCardProps) => {
  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg">
      <Link href={link} className="">
        <Image
          className={cn("w-full rounded-t-lg object-cover object-center")}
          src={image}
          alt={title}
          width={512}
          height={512}
        />
      </Link>
      <div className="p-4">
        <h1 className="title-font mb-3 text-lg font-medium tracking-tight text-gray-900">
          <Link href={link}>
            <span className="bg-gradient-to-r from-blue-200 to-blue-100 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_10px] group-hover:bg-[length:100%_10px]">
              {title}
            </span>
          </Link>
        </h1>
        <div className="flex w-full flex-col md:flex-row md:items-center md:gap-4">
          <div className="flex items-center gap-3">
            <Image
              src="/nihir.jpg"
              className="h-6 w-6 rounded-full"
              width={24}
              height={24}
              alt="Nihir Vedd"
            />
            <p className="text-sm text-gray-500">{author}</p>
          </div>
          <div className="hidden md:block">
            <svg
              fill="#d6d6d6"
              width="16px"
              height="16px"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              stroke="#d6d6d6"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M7.8 10a2.2 2.2 0 0 0 4.4 0 2.2 2.2 0 0 0-4.4 0z"></path>
              </g>
            </svg>{" "}
          </div>
          <p className="text-sm text-gray-500">{date}</p>
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;
